import GenreTag from './GenreTag';

const GenreList = ({ genres, accentColor }) => {
  if (!genres) {
    return <GenreTag text="No genres available" accentColor={accentColor} />;
  }

  const genreArray = Array.isArray(genres) ? genres : [genres];

  return genreArray.map((genre, index) => (
    <GenreTag key={index} text={genre} accentColor={accentColor} />
  ));
};

export default GenreList;